import React from 'react'

import CommonBlock from "../../../../app/quick-add/sections/view/components/forms/common-blocks/common-block"
import CommonForm from "../../../../app/quick-add/sections/view/components/forms/common-blocks/common-form"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import Views_addInitialProjectToSettings from "../../functions/add-initial-project-to-settings"
import quickAdd_getUsersIds from "../../../../app/quick-add/sections/view/components/forms/functions/get-users-ids"
import quickAdd_submitData from "../../../../app/quick-add/sections/view/components/forms/actions/submit-data"
import customViewFactory from "../../../model2/custom-view/factory"
import ViewPriorities_Conditions from "../conditions/conditions"

type Props = {
    className?      : string

    mode            : 'create' | 'update'
    view            : CustomView

    onSubmit        : func
}

// const debug = "PrioritiesForm"
const debug = false

export default class PrioritiesForm extends React.Component<Props> {

    public form: FormManager

    constructor(props: Props) {
        super(props);

        Views_addInitialProjectToSettings(props.view)

        const initFormData: any = {
            access      : props.view.access,
            sharedUsers : props.view.sharedUsers,
            name        : props.view.name,
            location    : props.view.params?.location || 'tools',

            settings    : props.view.settings || {}
        }

        debug && console.log(debug, 'constructor', props.view.parentProjectId, initFormData, props.view)

        const formStructure = {
            fields: {
                access      : { type: 'select',   isRequired: false,  label: 'Access'},
                sharedUsers : { type: 'select',   isRequired: false,  label: 'Shared users'},
                name        : { type: 'input',    isRequired: true},
                location    : { type: 'select',   isRequired: true},

                settings    : { type: 'input',    isRequired: false},
            },
            onSubmit        : this.onSubmit,
            isFormChanged   : true,
        }

        this.form = new FormManager(formStructure, initFormData)
    }

    onConditionsChange = (settings: any) => {
        debug && console.log(debug, 'onConditionsChange', settings)

        this.form.onFormComponentValueChange('settings', settings)

        const allUserIds = quickAdd_getUsersIds(settings.projects)
        const sharedUsers = this.form.getValue('sharedUsers')
        const newUsers = _.intersection(sharedUsers, allUserIds)
        this.form.setFieldValue('sharedUsers', newUsers)

        this.props.view.settings = _.assign({}, this.props.view.settings, settings)

        this.forceUpdate()
    }

    onSubmit = async (result: any) => {
        const data = await quickAdd_submitData(this.props.view, result)

        this.form.setFieldValue('name', '')
        this.form.reset()

        if (this.props.onSubmit && data) {
            const model = customViewFactory(data.view)
            this.props.onSubmit(model)
        }
    }

    render() {
        return (
            <CommonForm className={this.props.className} form={this.form} mode={this.props.mode}>
                <div className="tbl">
                    <CommonBlock form   = {this.form}
                                 mode   = {this.props.mode}
                                 view   = {this.props.view}/>
                </div>

                <ViewPriorities_Conditions view     = {this.props.view}
                                           onChange = {this.onConditionsChange}/>
            </CommonForm>
        )
    }
}